import React from "react";
import { connect } from "react-redux";
import { IStyle } from "../../../Types/Style";

import { AddButton, ButtonRow } from "../../Common/Components/FormComponents";
import { Section } from "../../Common/Styles/containers";
import { ErrorMsg } from "../../Common/Styles/DNDImage";
import { IState } from "../../reducer";
import { ICompleteOrganization, RequestState } from "../../types/common";

interface IApplyProps {
  style: IStyle;
  applyStyleToCurrentOrg: (styleId: string) => void;
  organization: ICompleteOrganization;
}

interface IApplyStateProps {
  patchOrganizationStatus: RequestState;
  patchOrganizationError: string | null;
}

type ApplyProps = IApplyProps & IApplyStateProps;

export const Apply: React.FC<ApplyProps> = props => {
  const { style, organization, patchOrganizationError, patchOrganizationStatus } = props;
  const applyStyleToCurrentOrg = () => {
    if (confirm("Are you sure to apply this theme to the current organisation?")) {
      props.applyStyleToCurrentOrg(props.style.styleId);
    }
  };
  const isSelectedTheme = style.styleId === organization.style;
  const isLoading = patchOrganizationStatus === RequestState.PENDING;
  const isDisabled = isLoading || isSelectedTheme;

  return (
    <Section>
      <h3>Apply to current organisation</h3>
      {isSelectedTheme && <i>This theme is applied to the current organisation.</i>}
      {isLoading && <p>Loading...</p>}
      {patchOrganizationError && <ErrorMsg>{patchOrganizationError}</ErrorMsg>}
      <ButtonRow width={12} margin={1}>
        <AddButton onClick={applyStyleToCurrentOrg} disabled={isDisabled}>
          Apply theme
        </AddButton>
      </ButtonRow>
    </Section>
  );
};

const mapStateToProps = (state: IState): IApplyStateProps => ({
  patchOrganizationError: state.App.ThemeManagement.patchOrganizationError?.message ?? null,
  patchOrganizationStatus: state.App.ThemeManagement.patchOrganizationStatus,
});

export default connect(mapStateToProps)(Apply);
